const ButtonLink = ({
  href = '',
  children,
  onClick = () => {}
}: {
  href?: string;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}) => {
  return (
    <a
      onClick={onClick}
      className='bg-white hover:bg-white-100 text-black font-bold py-2 px-4 rounded mb-4'
      href={href}
    >
      {children}
    </a>
  );
};

export default ButtonLink;
